import React from 'react';
import { BAR_KEY_COLORS } from './KeyboardVisualizer';
import type { KeyBindingsRailCategory } from '../../KeyBindings/KeyBindingsWindow';

export interface KeyBindingsRailItem {
  id: KeyBindingsRailCategory;
  label: string;
  testId: string;
  count: number;
  barId?: number;
}

export interface ActionCategoryFilterProps {
  categories: readonly KeyBindingsRailItem[];
  selectedCategory: KeyBindingsRailCategory;
  isSearchActive: boolean;
  onSelectCategory: (category: KeyBindingsRailCategory) => void;
}

export const ActionCategoryFilter: React.FC<ActionCategoryFilterProps> = ({
  categories,
  selectedCategory,
  isSearchActive,
  onSelectCategory,
}) => {
  return (
    <nav
      className="key-bindings-rail"
      role="tablist"
      aria-label="Key binding categories"
      data-testid="key-bindings-rail"
    >
      {categories.map((cat) => {
        const active = !isSearchActive && selectedCategory === cat.id;
        const barColor = cat.barId ? BAR_KEY_COLORS[cat.barId]?.border : undefined;
        return (
          <button
            key={cat.id}
            type="button"
            role="tab"
            aria-selected={active}
            data-testid={cat.testId}
            className={`key-bindings-rail-btn${active ? ' key-bindings-rail-btn--active' : ''}`}
            onClick={() => onSelectCategory(cat.id)}
          >
            <span className="key-bindings-rail-label">
              {barColor && (
                <span
                  className="key-bindings-rail-dot"
                  style={{ background: barColor }}
                  aria-hidden="true"
                />
              )}
              <span>{cat.label}</span>
            </span>
            <span className="key-bindings-rail-count">{cat.count}</span>
          </button>
        );
      })}
    </nav>
  );
};
